import {
  Input,
  Button,
  Table,
  Statistic,
} from "antd";
import { ChangeEvent, createElement, Fragment, KeyboardEvent, Props as ReactProps } from "react";
import styled from 'styled-components';
import Product from "../../../../entity/product";
import { OrderProductType } from '../../../../state/contentSelect';
import OrderProduct from "../../../../entity/orderProduct";
import Order from "../../../../entity/order";

type Props = ReactProps<HTMLSpanElement> & {
  order: Order;
  products: Product[];
  orderProducts: OrderProductType;
  updateOrderProductField: (orderProduct: OrderProduct, count: number) => void;
  onClickPaymentInfo: () => void;
};

const StyledContentLayout = styled.div`
  overflow: auto;
  height: auto;
`;

const CartSummary = (props: Props) => {
  const {
    orderProducts,
    updateOrderProductField,
    products,
    order,
    onClickPaymentInfo,
  } = props;
  const setOrderProduct = (orderProduct: OrderProduct, count: number) => {
    if (count >= 0 && orderProduct) {
      updateOrderProductField(orderProduct, count);
    }
  };
  const onKeyPress = (e: KeyboardEvent<HTMLInputElement>, orderProduct: OrderProduct, count: number) => {
    const key = 'Backspace';
    if (count < 10 && e.key === key) {
      setOrderProduct(orderProduct, 0);
    }
  };
  const columns = [{
    title: '商品名',
    dataIndex: 'title',
    render: (_: any, record: Product) => {
      return <span>{record.displayTitle()}</span>;
    }
  }, {
    title: '金額',
    dataIndex: 'price',
    render: (text: any) => {
      return (
        <Statistic
          value={text as number}
          prefix="¥"
          valueStyle={{ fontSize: 16 }}
        />
      )
    }
  }, {
    title: '数量',
    dataIndex: 'count',
    render: (_: any, record: Product) => {
      const orderProduct = orderProducts.get(record.id) as OrderProduct;
      return (
        <Input
          min={0}
          type="number"
          onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => onKeyPress(e, orderProduct, orderProduct.count)}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setOrderProduct(orderProduct, parseInt(e.target.value))}
          value={orderProduct.count}
          style={{ width: 70 }}
        />
      )
    }
  }, {
    title: '合計',
    dataIndex: 'sumPrice',
    render: (_: any, record: Product) => {
      const orderProduct = orderProducts.get(record.id) as OrderProduct;
      const sumPrice = orderProduct.price * orderProduct.count;
      return (
        <Statistic
          value={sumPrice as number}
          prefix="¥"
          valueStyle={{ fontSize: 16 }}
        />
      )
    }
  }];

  return (
    <StyledContentLayout>
      <Table
        columns={columns}
        dataSource={products}
        bordered={true}
        rowKey="id"
        title={() => '購入商品'}
        pagination={false}
        footer={() => {
          return(
            <Fragment>
              <Statistic
                value={order.totalProductPrice}
                prefix="商品合計: ¥"
                valueStyle={{ fontSize: 16 }}
              />
              <Statistic
                value={order.totalTaxPrice}
                prefix="消費税: ¥"
                valueStyle={{ fontSize: 16 }}
              />
              <Statistic
                value={order.totalPrice}
                prefix="合計: ¥"
                valueStyle={{ fontSize: 16 }}
              />
            </Fragment>
          )
        }}
      />
      <Button block={true} size="large" type="primary" onClick={onClickPaymentInfo}>
        注文画面に進む
      </Button>
    </StyledContentLayout>
  );
};

export default CartSummary;
